const isValidZambiaPhoneNumber = (phoneNumber: string): boolean => {
  phoneNumber = phoneNumber.slice(SUPPORTED_DIAL_CODES[0].dialCode.length)
  // 0 + 9 digits (10 digits) or just 9 digits
  const mobilePattern = /^(0\d{9}|\d{9})$/
  return mobilePattern.test(phoneNumber)
}

const isValidNigerianPhoneNumber = (phoneNumber: string): boolean => {
  phoneNumber = phoneNumber.slice(SUPPORTED_DIAL_CODES[1].dialCode.length)
  // Mobile numbers: optional 0 + (70, 80, 81, 90, 91) + 8 digits
  const mobilePattern = /^(0?70|0?80|0?81|0?90|0?91)[0-9]{8}$/
  return mobilePattern.test(phoneNumber)
}

const isValidGhanaPhoneNumber = (phoneNumber: string): boolean => {
  phoneNumber = phoneNumber.slice(SUPPORTED_DIAL_CODES[2].dialCode.length)
  // Landlines: starts with 02 or 03, then 2-9, then 7 more digits
  const landline = /^0[23][2-9]\d{7}$/
  // Mobile: starts with 02, 03, 05, or 07, then 8 more digits
  const mobile = /^0[2357]\d{8}$/
  // Toll-free: starts with 800, then 5 more digits
  const tollFree = /^800\d{5}$/
  // Premium: starts with 9, then 7 more digits
  const premium = /^9\d{7}$/

  return landline.test(phoneNumber) ||
         mobile.test(phoneNumber) ||
         tollFree.test(phoneNumber) ||
         premium.test(phoneNumber)
}

export const SUPPORTED_DIAL_CODES = [
  {
    iso2: "zm",
    dialCode: "+260",
    validator: isValidZambiaPhoneNumber,
    errorMessage: "Invalid Zambia phone number. Must be 9-10 digits"
  },
  {
    iso2: "ng",
    dialCode: "+234",
    validator: isValidNigerianPhoneNumber,
    errorMessage: "Invalid Nigerian phone number. Must be 10-11 digits starting with 70, 80, 81, 90, or 91"
  },
  {
    iso2: "gh",
    dialCode: "+233",
    validator: isValidGhanaPhoneNumber,
    errorMessage: "Invalid Ghana phone number"
  }
];

export type SupportedDialCode = typeof SUPPORTED_DIAL_CODES[number]["dialCode"];
export type SupportedCountryCode = typeof SUPPORTED_DIAL_CODES[number]["iso2"];

export const validatePhoneNumber = (phoneNumber: string): true | string => {
  const country = SUPPORTED_DIAL_CODES.find(c => phoneNumber.startsWith(c.dialCode));

  if (!country) {
    return true;
  }

  return country.validator(phoneNumber) || country.errorMessage;
}
